import { render, staticRenderFns } from "./AddressFormForRegistration.vue?vue&type=template&id=4eb3cce5&scoped=true"
import script from "./AddressFormForRegistration.vue?vue&type=script&lang=js"
export * from "./AddressFormForRegistration.vue?vue&type=script&lang=js"
import style0 from "./AddressFormForRegistration.vue?vue&type=style&index=0&id=4eb3cce5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb3cce5",
  null
  
)

export default component.exports